import { InjectionToken } from '@angular/core';

export const CONTEXT_MENU_OPTIONS = new InjectionToken('CONTEXT_MENU_OPTIONS');
